import React from 'react';

import { cn } from '@elara/client-core/lib/utils';

import { ThinkingText } from '#ui/thinking-text.js';

export interface WidgetLoadingStateProps {
  /** The loading message to display */
  message?: string;
  /** Additional CSS classes to apply */
  className?: string;
}

/**
 * Reusable loading state component for widgets.
 * Displays an animated loading message with consistent styling.
 */
export function WidgetLoadingState({ message = 'Loading...', className }: WidgetLoadingStateProps) {
  return (
    <div className={cn('mb-4', className)}>
      <ThinkingText text={message} />
    </div>
  );
}
